"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function pay(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M20.1828 11.772C20.1417 11.6887 20.0872 11.6127 20.0215 11.547C18.595 9.9315 15.6918 6.75 15.6918 6.75L12.004 10.7835L8.26905 6.78825C8.26905 6.78825 5.33205 9.9975 3.8928 11.6302C3.7053 11.8148 3.7053 12.1477 3.8733 12.3442C4.62105 13.1962 8.2938 17.2463 8.2938 17.2463L11.9988 13.1857L15.6783 17.25L20.116 12.3405C20.116 12.3405 20.2098 12.243 20.23 12.1777C20.2735 12.0427 20.242 11.8958 20.1828 11.772ZM5.9388 12.2213C5.8188 12.0795 5.8593 11.8568 5.97105 11.7225C6.44055 11.1877 8.3193 9.1725 8.3193 9.1725L10.9368 11.9513L8.3148 14.8193C8.3148 14.8193 6.7098 13.1062 5.9388 12.2213ZM17.9298 12.3157C17.8745 12.4105 17.8102 12.4996 17.7378 12.582L15.7053 14.7908L13.0803 12L15.6633 9.16875C15.6633 9.16875 17.1513 10.71 17.833 11.5388C17.8908 11.6108 17.959 11.679 17.9883 11.7705C18.0505 11.9497 18.0108 12.1493 17.929 12.315", fill: color }));
}
exports["default"] = pay;
//# sourceMappingURL=pay.js.map